import React from "react";
import { LoginContentWrapper } from "Components";

const ConfirmReset = (): React.JSX.Element => {
  return (
    <LoginContentWrapper
      title="Password changed!"
      byline="You can now log in with your email and new password."
    />
  );
};

export default ConfirmReset;
